// LexiQamus public surface pack (search + pre-search innovations landing)
import 'stylesheets/lexiqamus'
import 'stylesheets/lexiqamus_announcements'
import '../lexiqamus_announcements'

// Only register innovations announcement images when the home viewport is present (no searched_text).
// This avoids ~4.7 MB of image requests on every search results page load.
if (document.querySelector('.lexiqamus-home-viewport')) {
  const innovationAnnouncementImages = require.context('../images/lexiqamus/innovation_announcements', false, /\.(png|jpe?g|gif|webp)$/i)
  innovationAnnouncementImages.keys().forEach(innovationAnnouncementImages)
}
